<button type="button" class="btn-dt-action border-0 text-center" [disabled]="!allowed_to_update">
    <div class="icon-position">
      <img class="icon-btn-action" src="assets/icons/action-icon.svg">
    </div>
    <span>{{label}}</span>
  </button>
